var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.6C1 17.6392 1 13.1587 2.7439 9.73615C4.27787 6.72556 6.72556 4.27787 9.73615 2.7439C13.1587 1 17.6392 1 26.6 1H75.4C84.3608 1 88.8413 1 92.2638 2.7439C95.2744 4.27787 97.7221 6.72556 99.2561 9.73615C101 13.1587 101 17.6392 101 26.6V75.4C101 84.3608 101 88.8413 99.2561 92.2638C97.7221 95.2744 95.2744 97.7221 92.2638 99.2561C88.8413 101 84.3608 101 75.4 101H26.6C17.6392 101 13.1587 101 9.73615 99.2561C6.72556 97.7221 4.27787 95.2744 2.7439 92.2638C1 88.8413 1 84.3608 1 75.4V26.6Z",
    fill: "#171717",
    stroke: "#444444",
    strokeDasharray: "5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 56L45.3371 50.4129C45.7615 49.9885 46.3372 49.75 46.9375 49.75C47.5378 49.75 48.1135 49.9885 48.5379 50.4129L53.5 55.375M53.5 55.375L55.375 57.25M53.5 55.375L55.9621 52.9129C56.3865 52.4885 56.9623 52.25 57.5625 52.25C58.1627 52.25 58.7385 52.4885 59.1629 52.9129L62.25 56",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.375 46C55.7201 46 56 45.7202 56 45.375C56 45.0298 55.7201 44.75 55.375 44.75M55.375 46C55.0299 46 54.75 45.7202 54.75 45.375C54.75 45.0298 55.0299 44.75 55.375 44.75M55.375 46V44.75",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6225 60.684C39.125 58.9307 39.125 56.2871 39.125 51C39.125 45.7128 39.125 43.0692 40.6225 41.3159C40.8351 41.067 41.067 40.8351 41.3159 40.6225C43.0692 39.125 45.7128 39.125 51 39.125C56.2871 39.125 58.9307 39.125 60.684 40.6225C60.933 40.8351 61.1649 41.067 61.3775 41.3159C62.875 43.0692 62.875 45.7128 62.875 51C62.875 56.2871 62.875 58.9307 61.3775 60.684C61.1649 60.933 60.933 61.1649 60.684 61.3775C58.9307 62.875 56.2871 62.875 51 62.875C45.7128 62.875 43.0692 62.875 41.3159 61.3775C41.067 61.1649 40.8351 60.933 40.6225 60.684Z",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoimage);
export default __webpack_public_path__ + "static/media/noimage.4fa80c498f84cf71b5762d67f8710e37.svg";
export { ForwardRef as ReactComponent };